/**
 * @generated SignedSource<<69098c10b25eb7490d88cf8d7b2af13b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type searchFollowTheTimelineArticleSearchResultStreamItem$data = ReadonlyArray<{
  readonly __typename: "ArticleSearchResultStreamItemTimelineItem";
  readonly content: {
    readonly " $fragmentSpreads": FragmentRefs<"entrySearchFollowTheTimelineItemEntryContent">;
  } | null | undefined;
  readonly id: string;
  readonly itemOrder: number;
  readonly order: number;
  readonly " $fragmentType": "searchFollowTheTimelineArticleSearchResultStreamItem";
} | {
  readonly __typename: "ArticleSearchResultStreamItemTimelineSummary";
  readonly id: string;
  readonly order: number;
  readonly summary: string;
  readonly " $fragmentSpreads": FragmentRefs<"itemSearchFollowTheTimelineArticleSearchResultStreamItemTimelineSummary">;
  readonly " $fragmentType": "searchFollowTheTimelineArticleSearchResultStreamItem";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "searchFollowTheTimelineArticleSearchResultStreamItem";
}>;
export type searchFollowTheTimelineArticleSearchResultStreamItem$key = ReadonlyArray<{
  readonly " $data"?: searchFollowTheTimelineArticleSearchResultStreamItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchFollowTheTimelineArticleSearchResultStreamItem">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "searchFollowTheTimelineArticleSearchResultStreamItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "itemSearchFollowTheTimelineArticleSearchResultStreamItemTimelineSummary"
        }
      ],
      "type": "ArticleSearchResultStreamItemTimelineSummary",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemOrder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "entrySearchFollowTheTimelineItemEntryContent"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "ArticleSearchResultStreamItemTimelineItem",
      "abstractKey": null
    }
  ],
  "type": "ArticleSearchResultStreamItem",
  "abstractKey": "__isArticleSearchResultStreamItem"
};
})();

(node as any).hash = "0459c0a168894daac0ab808360febf6d";

export default node;
